'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserBlitz } from '../../Entities/User/UserBlitz';
import { UserBlitzCollection } from '../../Collections/User/UserBlitzCollection';

export class UserBlitzRepository extends CoreRepository {
  public getUserBlitzs(options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserBlitzs(options).then((response) => {
      const collection = new UserBlitzCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserBlitz();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addUserBlitz(payload: object = {}) {
    return this.webAPI.addUserBlitz(payload).then((response) => {
      const userBlitz = new UserBlitz();
      userBlitz.hydrate(response);

      return userBlitz;
    });
  }

  public removeUserBlitz(blitzId: number) {
    return this.webAPI.removeUserBlitz(blitzId).then((response) => {
      return response;
    });
  }

  /*
    public getUserBlitz(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getUserBlitz(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let UserBlitz = new UserBlitz();
            UserBlitz.hydrate(response);

            return UserBlitz;
        });
    }
    */

  /*
    public updateUserBlitz(payload: object = {}){  
        return this.webAPI.updateUserBlitz(payload)
        .then( response => {
            let UserBlitz = new UserBlitz();
            UserBlitz.hydrate(response);

            return UserBlitz;
        });
    }
    */
}
